(function () {
  document.querySelectorAll('.acc-ellaola-lp-01-offer').forEach(function (root) {
    var card = root.querySelector('.acc-ellaola-lp-01-offer__card');
    var sel = root.querySelector('.acc-ellaola-lp-01-offer__agesel');
    var img = root.querySelector('.acc-ellaola-lp-01-offer__media-img');
    var cta = root.querySelector('[data-acc-ellaola-lp-01-sticky-hide]');
    var nowEl = root.querySelector('.acc-ellaola-lp-01-offer__price-now');
    var oldEl = root.querySelector('.acc-ellaola-lp-01-offer__price-old');
    var saveEl = root.querySelector('.acc-ellaola-lp-01-offer__price-save');
    if (!sel || !card) return;

    function setText(el, value) {
      if (!el) return;
      if (value) {
        el.textContent = value;
        el.hidden = false;
      } else {
        el.textContent = '';
        el.hidden = true;
      }
    }

    function handleFromBtn(btn) {
      if (!btn) return '';
      return btn.getAttribute('data-handle') || '';
    }

    function set(btn) {
      if (!btn) return;
      var color = btn.getAttribute('data-color') || '#9a6aa6';
      var url = btn.getAttribute('data-url') || '';
      var src = btn.getAttribute('data-img') || '';
      var alt = btn.getAttribute('data-alt') || '';
      card.style.setProperty('--acc-ellaola-lp-01-age', color);
      if (img && src) {
        img.src = src;
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.alt = alt;
      }
      if (cta && url) cta.href = url;
      setText(nowEl, btn.getAttribute('data-now'));
      setText(oldEl, btn.getAttribute('data-old'));
      setText(saveEl, btn.getAttribute('data-save'));
      [].forEach.call(sel.querySelectorAll('.acc-ellaola-lp-01-offer__age-btn'), function (b) {
        var on = b === btn;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.setAttribute('aria-selected', on ? 'true' : 'false');
        b.tabIndex = on ? 0 : -1;
      });
      document.dispatchEvent(new CustomEvent('acc-ellaola-lp-01:agechange', {
        detail: {
          url: url,
          now: btn.getAttribute('data-now') || '',
          old: btn.getAttribute('data-old') || '',
          color: color,
          handle: handleFromBtn(btn)
        }
      }));
    }

    var tabs = sel.querySelectorAll('.acc-ellaola-lp-01-offer__age-btn');
    [].forEach.call(tabs, function (b, i) {
      b.addEventListener('click', function () { set(b); });
      b.addEventListener('keydown', function (e) {
        var next = -1;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = (i + 1) % tabs.length;
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = (i - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = tabs.length - 1;
        if (next < 0) return;
        e.preventDefault();
        set(tabs[next]);
        tabs[next].focus();
      });
    });
  });
})();
